// extracted by mini-css-extract-plugin
module.exports = {"mr-loading":"_1Uy5xF3GV2M3xcNMaF2lWZ","mrTop-loading":"_1Gl798-pvBW_CBNOaVi2aL"};